import { useGetFunctionalitiesQuery } from '@app/api/functionalitiesApi';
import { useGetActiveLoansQuery, useGetPastLoansQuery } from '@app/api/loanApplicationsApi';
import { useFetchCurrentSolvencyDeclarationQuery } from '@app/api/solvencyDeclarationApi';
import { useGetTermsAndConditionsQuery } from '@app/api/termsAndConditionsApi';
import { TermsAndConditionsType } from '@app/api/types';
import { LoanStatuses } from '@app/configs/loanApplication';
const ACTIVE_STATUSES = [
    LoanStatuses.Collecting,
    LoanStatuses.Collected,
    LoanStatuses.Overdue,
    LoanStatuses.Active,
    LoanStatuses.Submitted,
];
export const useBorrowerData = () => {
    const { data: termsAndConditions, isLoading: termsAndConditionsLoading } = useGetTermsAndConditionsQuery(TermsAndConditionsType.BORROWER);
    const skip = !(termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.accepted);
    const { data: loanApplications = [], isLoading: loadingActiveLoan, isFetching: fetchingActiveLoan, } = useGetActiveLoansQuery(undefined, { skip });
    const { data: functionalities } = useGetFunctionalitiesQuery();
    const { data: pastLoanApplications = [], isLoading: loadingPastLoans } = useGetPastLoansQuery(undefined, { skip });
    const { isLoading: solvencyDeclarationLoading } = useFetchCurrentSolvencyDeclarationQuery(undefined, { skip });
    const activeLoans = loanApplications.filter((loan) => ACTIVE_STATUSES.includes(loan.status));
    return {
        termsAndConditions,
        activeLoans,
        pastLoanApplications,
        functionalities,
        loadingPastLoans,
        isLoading: !termsAndConditions ||
            termsAndConditionsLoading ||
            loadingActiveLoan ||
            solvencyDeclarationLoading ||
            fetchingActiveLoan,
    };
};
